"use strict";
/// <reference path="irep.js"/>

IREP.raffle = (function () {
    var init = function (options) {
        $("#orderButton").click(function () {
            var form = $("#addProductContainer");
            var submit = form.find("#submitOrder");
            submit.trigger("click");
        });
    };

    return {
        init: init
    };
})();


IREP.raffle.carryoverDetail = (function () {
    var init = function (options) {
        $("#PurchaseCarryover").click(PurchasePoints);
        $("#ClickHere").click(ShowPurchase);
        FillDropdown(IREP.options.user.chipCount);
        GetCarryoverPoints();
    };


    var GetCarryoverPoints = function () {
        IREP.callApi("/raffles/carryovertotal", "GET")
            .done(function (data) {
                SetCarryoverLabel(data.carryoverPoints);
            })
        .fail(function (jqXHR, textStatus, errorThrown) {

        });
    };

    var FillDropdown = function (points) {
        var dropdown = $("#OrderPointsList");
        dropdown.children().remove();
        var len = Math.floor(points / 100) * 100;
        for (var i = len; i >= 0; i -= 100) {
            var value;
            if (i === 0) {
                value = i;
            } else {
                 value = i / 10;
            }

            dropdown.prepend($("<option></option")
                .prop("value", value)
                .text(value));
        }
        $('#OrderPointsList').val('0');
    };

    var PurchasePoints = function (e) {
        e.preventDefault();
        var points = $("#OrderPointsList").val();
        IREP.callApi("raffles/ordercarryoverpoints/" + points, "POST")
            .done(function (data) {
                SetCarryoverLabel(data.carryoverPoints);
                FillDropdown(data.userPointTotal);
                HidePurchase();

            })
            .fail(function (jqXHR, textStatus, errorThrown) {

        });
    };

    var ShowPurchase = function () {
        $("#orderPoints").css("display", "block");
        $("#ClickHere").css("display", "none");
 
    };

    var HidePurchase = function () {
        $("#orderPoints").css("display", "none");
        $("#ClickHere").css("display", "block");
    };

    var SetCarryoverLabel = function (points) {
        $("#carryOver").text(points);
    };
    return {
        init: init
    };
})();

IREP.raffle.checkOut = (function () {
    var init = function (options) {
        var countryDropDown = $("#country");
        var stateDropDown = $("#State");
        FillStateDropDown(countryDropDown.val());
        countryDropDown.on("change", function () {
            FillStateDropDown(countryDropDown.val());
        });
        stateDropDown.on("change", function () {
            $("#StateValue").val($("#State option:selected").text());
            $("#StateId").val($("#State option:selected").val());
        });

    };

    var FillStateDropDown = function (countryCode) {
        IREP.callApi("country/states/" + countryCode, "GET").done(function (data) {
            $("#State").children().remove();
            if (data.states.length > 0) {
                $("#State").show();
                $("#State").siblings().show();
                for (var i = 0; i < data.states.length; i++) {
                    var state = data.states[i];
                    var $dropOption = $("<option>", { "value": state.id, "text": state.name });
                    $("#State").append($dropOption);
                }
                $("#StateValue").val($("#State option:first").text());
                $("#StateId").val($("#State option:first").val());
            } else {
                $("#State").hide();
                $("#State").siblings().hide();
                $("#StateValue").val('');
                $("#StateId").val('0');
            }
        });
    };
    return {
        init: init
    };
})();

IREP.raffle.winners = (function () {
    var bodyContainer = $("#contentContainer");
    var IsLoading = false;
    var init = function () {
        $(".product").click(toggleWinners);
    };

    var toggleWinners = function () {
        if (!IsLoading) {
            IsLoading = true;
            var productContainer = $(this);
            var existingProductContainer = $("#drawercontainer");
            var existingPopupId = existingProductContainer.data("product-id");
            var productId = productContainer.data("product-id");
            closeDrawer();
            
            if (existingPopupId !== productId) {
                loadWinnersDetail(productId, productContainer);
                IsLoading = false;
            } else {
                IsLoading = false;
            }
        }
        return false;
    };

    var closeDrawer = function() {
        $(".product.selected").removeClass("selected");
        $("#drawercontainer").fadeOut("fast", function () {
            $(this).remove();
        });
        $("#overlay").remove();
    };

    var loadWinnersDetail = function(productId, productContainer) {
        productContainer.addClass("selected");
        var detailsButton = productContainer.find(".detailsButton");
        var drawerTemplate = Handlebars.compile($("#drawertemplate").html());
        var context = { productid: productId, "class": "productPopup container" };

        $(productContainer).append(drawerTemplate(context));

        var popup = productContainer.find($("#drawercontainer"))
            .click(function () { return false; });


        var borderWidth = parseInt($(".productPopup").css("border-top-width"), 10);
        popup.css({
            //top: detailsButton.offset().top + detailsButton.outerHeight() + borderWidth,
            left: bodyContainer.offset().left,
            position: 'fixed',
            bottom: 0,
            width: bodyContainer.width()
        });

        var drawer = IREP.drawer.init({
            template: popup,
            getUrl: productContainer.find("a").prop("href"),
            animateOnInit: true,
            useOverlay: true,
            animatePosition: "bottom",
            closeDrawer: closeDrawer
        });
    };
    
    return {
        init: init
    };
})();